module.exports = __webpack_public_path__ + "static/white-logo-2a2ec789fe775219a627007f74db7bda.png";